<template>
      <ValidationProvider :tag="tag" :rules="rules" :name="name" :class="$style['wt-form-list-item']"  class="wt-form-list-item"  :style="{lineHeight:lineHeight+'px'}" v-slot="{ errors }">
          <td valign="top">
            <slot name="required"/>
          </td>
          <td class="label-text" :align="align" ref="td">
              <div class="label-content" :style="{lineHeight:lineHeight+'px',color:'#222',width:widthMax+'px',justifyContent:(align==='left'?'flex-start':'')}">
                <span class="is-required" v-if="showRequiredSymbol">*</span>
                  {{label}}
              </div>
          </td>
          <td class="label-slot">
            <div :class="(errors&&errors.length)?'has-error':'nomal-value'">
            <slot/>
            <span class="error-message" v-if="showError">{{ errors[0] }}</span>
            </div>
          </td>
      </ValidationProvider>
</template>

<script>
// import '../../../utils/validate'
// 组件class前缀
const prefixCls = 'wt-form-item'
export default {
  name: 'wt-form-item',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    showRequiredSymbol(){
      return !(this.$slots.required&&this.$slots.required.length)&&this.required
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
   //设置label宽度
    labelWidth: {
      type: String,
      default: ''
    },
    //是否是必填字段
    required: {
      type: Boolean,
      default: false
    },
    widthArr: {
      type: Array,
      default: function () {
        return []
      }
    },
    widthMax: {// 所有子模块中的最大值
      type: [Number, String],
      default: ''
    },
    //设置行高
    lineHeight: {
      type: String,
      default: '55'
    },
    //验证规则
    rules:String,
    name:String,
    //字段label的tag
    tag:{
      type:String,
      default:"tr"
    },
    //label所在td内容的align（right/left/center）
    align:{
      type:String,
      default:"right"
		},
		showError:{
			type:Boolean,
			default:true
		}
  },
  data () {
    return {
      width_item: ''
    }
  },
  watch: {
    width_item (val) {
      // 1、子模块样式。所有子模块的label右对齐
      // a、每个子模块中，随意挑选一个pt-form-list-item（因为同一个子模块，label的宽度是相等的）,调用widthItem方法，在此方法中，将每一次获取的宽度push进一个数组。
      // b、取出数组中的最大值，在每个子模块中，随意挑选一个pt-form-list-item，将最大值（widthMax）传入
      this.$emit('widthItem', val)
    }
  },
  created () {
    this.$nextTick(_ => {
      // 获取第一个td即label部分的宽度
      this.width_item = this.$refs.td && this.$refs.td.getBoundingClientRect() && this.$refs.td.getBoundingClientRect().width
    })
  },
  destroyed () {
    this.width_max = null
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.wt-form-list-item{
    display: table-row;
    // align-items: center;
    margin-bottom: 10px;
    &:last-child{
        margin-bottom: 0;
    }
    :global{
    // >span{
    //     text-align: right;
    //     margin-right: 10px;
    //     color: #333333;
    //     vertical-align: middle;
    //     font-size: 15px;
    // }
    .form-item-content{
        flex: 1;
        align-self: center;
        overflow: hidden
    }
    .red{
        color:red;
    }

.label-text{
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    margin-right: 10Px;
    white-space:nowrap;
    color: #282828
}
.label-content{
    display: flex;
    justify-content: flex-end;
    white-space: nowrap;
}
.is-required{
    color: red!important;
    margin-right: 3px;
}
.label-slot{
    width: 100%;
    .error-message{
      color: red;
      font-size: 10px;
      line-height: 20PX
    }
}

  .has-error{
    line-height: 40Px;
    display: inline-grid;
    flex-direction: column;
  }
    }
}
</style>
